import PlayButton from "@/components/atoms/play-icon";
import { Link } from "@/i18n/navigation";
import { formatDate, formatDateTime } from "@/lib/utils";
import { useTranslations } from "next-intl";
import Image from "@/components/atoms/image";
import React from "react";

export default function CardListItem({ video, type }: any) {
  const t = useTranslations("Filters");
  return (
    <div className="border-b border-neutral-200 group py-32">
      <Link
        title={video.title}
        aria-label={video.title}
        href={type + "/" + video.slug as any}
        className="block rounded focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-primary-600"
      >
        <article className="flex flex-col md:flex-row md:items-center gap-8 md:gap-32">
          {video?.publicationType === "video" && (
            <span className="text-primary-600 text-s-regular order-1 md:order-none md:hidden">
              {video.region && t(video?.region.toLowerCase())}
            </span>
          )}

          {video?.categories?.length > 0 && (
            <span className="text-primary-600 text-s-regular order-1 md:order-none md:hidden">
              {video?.categories[0].name}
            </span>
          )}

          <div className="w-full md:w-3/12 h-[140px] md:h-[100px] relative order-2 md:order-last">
            <div
              className=" relative w-full h-full cursor-pointer"
            >
              {video.featuredImage?.url && <Image
                src={video.featuredImage?.url ? video.featuredImage.url : ""}
                alt={video.featuredImage?.alt ? video.featuredImage.alt : ""}
                fill
                sizes="(max-width: 640px) 100vw, (max-width: 768px) 50vw, 33vw"
                className="object-cover rounded"
                quality={80}
                aria-hidden="true"
              /> }

              {video?.publicationType === "video" && (
                <div
                  className="absolute inset-0 flex items-center justify-center"
                  aria-hidden="true"
                >
                  <div className="rounded-full z-30 p-3 transform transition-transform duration-200">
                    <PlayButton
                      size={40}
                      color="#ffffff"
                      hoverColor="#ffffff"
                    />
                  </div>
                </div>
              )}
              {(video.featuredImage?.url || video?.publicationType === "video") && <div className="absolute inset-0 z-20 opacity-0 group-hover:opacity-100 group-focus-within:opacity-100 transition-opacity bg-bupi-hoverGradient pointer-events-none" /> }
            </div> 
          </div>

          <header className="w-full xl:w-9/12 order-4 xl:order-first">
            {video?.publicationType === "video" && (
              <span
                className="hidden xl:inline-block text-primary-600 text-s-regular"
              >
                {video.region && t(video?.region.toLowerCase())}
              </span>
            )}

            {video?.categories?.length > 0 && (
              <span
                className="hidden xl:inline-block text-primary-600 text-s-regular"
              >
                {video?.categories?.map((category: any) => category.name).join(", ")}
              </span>
            )}

            {video?.publishedAt && (
              <time
                className="block text-m-regular text-neutral-900 py-8 order-3 xl:order-none"
                dateTime={formatDateTime(video.publishedAt)}
              >
                {formatDate(video.publishedAt)}
              </time>
            )}

            <h2 className="line-clamp-2 text-l-bold xl:text-xl-bold text-neutral-900 break-words my-8 xl:mt-0 group-focus-within:text-primary-700 group-focus-within:underline">
              {video.title}
            </h2>
            <span className="line-clamp-3 text-m-regular text-neutral-900">
              {video.description}
            </span>
          </header>
        </article>
      </Link>
    </div>
  );
}
